export var FunnelStage;
(function (FunnelStage) {
    FunnelStage["FULL_FUNNEL"] = "Full Funnel";
    FunnelStage["PRE_CLICK"] = "Ad Creative";
    FunnelStage["POST_CLICK"] = "Storefront";
})(FunnelStage || (FunnelStage = {}));
export var PerformanceInsightPhase;
(function (PerformanceInsightPhase) {
    PerformanceInsightPhase["PRE_CLICK"] = "Ad Creative";
    PerformanceInsightPhase["POST_CLICK"] = "Storefront";
})(PerformanceInsightPhase || (PerformanceInsightPhase = {}));
export var PerformanceInsightImpactLevel;
(function (PerformanceInsightImpactLevel) {
    PerformanceInsightImpactLevel["HIGH_IMPACT"] = "HIGH IMPACT";
    PerformanceInsightImpactLevel["MEDIUM_IMPACT"] = "MEDIUM IMPACT";
    PerformanceInsightImpactLevel["LOW_IMPACT"] = "LOW IMPACT";
})(PerformanceInsightImpactLevel || (PerformanceInsightImpactLevel = {}));
